import get from 'lodash/get';

import { loginRequest, loginTwoFactorRequest, logoutRequest, resetPasswordRequest, getPermissionsRequest, getAccountInfoRequest, getAccountProfileId } from '../../api/requests';

export const USER_UPDATE = 'USER_UPDATE';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';


export const login = ({ username, password }) => async dispatch => {
  try {
    const response = await loginRequest({username, password});

    if (get(response, 'data.access_token')) {
      window.localStorage.setItem('token', get(response, 'data.access_token'));
      setPermissions(get(response, 'data.access_token'))(dispatch);
      setAccountInfo(get(response, 'data.access_token'))(dispatch);
    }

    return response;
  } catch (e) {
    throw new Error(get(e, 'response.data.error'));
  }
}

export const loginTwoFactor = ({ username, password, code }) => async dispatch => {
  try {
    const response = await loginTwoFactorRequest({ username, password, code });
    window.localStorage.setItem('token', get(response, 'data.access_token'));
    setPermissions(get(response, 'data.access_token'))(dispatch);
    setAccountInfo(get(response, 'data.access_token'))(dispatch);
    // dispatch(({ type: USER_UPDATE, payload: { token: get(response, 'data.access_token') } }));
    return response;
  } catch (e) {
    throw new Error(get(e, 'response.data.error'));
  }
}

export const setPermissions = token => async dispatch => {
  try {
    const { data } = await getPermissionsRequest();
    const permissions = data.filter(permission => get(permission, 'state') === 'active');

    dispatch(({ type: USER_UPDATE, payload: { token, permissions } }));
    return token;
  } catch (e) {
    if ([401, 422].includes(get(e, 'response.status'))) { logoutHandle(dispatch); }
    // throw new Error(get(e, 'response.data.error'));
  }
};


export const setAccountInfo = token => async dispatch => {
  try {
    const response = await getAccountInfoRequest();
    dispatch(({ type: USER_UPDATE, payload: { token, info: get(response, 'data') } }));
    return token;
  } catch (e) {
    if ([401, 422].includes(get(e, 'response.status'))) { logoutHandle(dispatch); }
    // throw new Error(get(e, 'response.data.error'));
  }
};

export const setAccountProfileId = (password) => async dispatch => {
  try {
    const response = await getAccountProfileId(password);
    dispatch(({ type: USER_UPDATE, payload: { profileId: get(response, 'data.user_id') } }));
  } catch (e) {
    if ([401, 422].includes(get(e, 'response.status'))) { logoutHandle(dispatch); }
    // throw new Error(get(e, 'response.data.error'));
  }
};

const logoutHandle = dispatch => {
  window.localStorage.removeItem('token');
  dispatch(({type: USER_SIGN_OUT}));
};

export const logout = () => async dispatch => {

  try {
    await logoutRequest();
    logoutHandle(dispatch);
  } catch (e) {
    logoutHandle(dispatch);
  }
}

export const resetPassword = ({ username }) => async () =>
  resetPasswordRequest({ username });


  //export const logout = () => async (dispatch, getState) => {
  // console.log(getUserToken(getState()));
  // try {
  //   return await loginRequest({ username, password });
  //   // dispatch(({ type: USER_UPDATE, payload: { token } }));
  //   // return token;
  // } catch (e) {
  //   return e;
  // }

// export const signOut = () => dispatch => dispatch(({ type: USER_SIGN_OUT }));



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js